//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ItemsSearchField from '../../../../../components/Field/ItemsSearchField.vue'
import { createFieldConfig } from '../../../../../components/QSelectUtils.js'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    workTypes: {
      type: Array,
      default () {
        return []
      }
    },
    hideWorkTypes: {
      type: Boolean,
      default: false
    },
    workTypesReadonly: {
      type: Boolean,
      default: false
    },
    workTypesFieldLabel: {
      type: String,
      default: 'РАБОТЫ'
    },
    workTypesDialogLabel: {
      type: String,
      default: 'ВЫБОР РАБОТ'
    },
    availableWorkTypesFn: {
      type: Function,
      default () {
        return () => []
      }
    },
    workPackages: {
      type: Array,
      default () {
        return []
      }
    },
    hideWorkPackages: {
      type: Boolean,
      default: false
    },
    workPackagesReadonly: {
      type: Boolean,
      default: false
    },
    workPackagesFieldLabel: {
      type: String,
      default: 'КОМПЛЕКСЫ РАБОТ'
    },
    workPackagesDialogLabel: {
      type: String,
      default: 'ВЫБОР КОМПЛЕКСОВ РАБОТ'
    },
    availableWorkPackagesFn: {
      type: Function,
      default () {
        return () => []
      }
    }
  },
  data: function () {
    return {
      workTypesFieldConfig: createFieldConfig({ allRecordsFn: this.availableWorkTypesFn }),
      workPackagesFieldConfig: createFieldConfig({ allRecordsFn: this.availableWorkPackagesFn })
    }
  },
  methods: {
    setWorkTypes: function (value) {
      this.$emit('update:work-types', value)
    },
    setWorkPackages: function (value) {
      this.$emit('update:work-packages', value)
    }
  }
}

